///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { FormattedMessage } from "react-intl";

import Chevron from "../icons/ChevronDown";
import messages from "../../helpers/messages";

export const Pagination = ({
  offset,
  limit,
  total,
  onChange,
  perPageOptions
}) => {
  return (
    <div className="pagination fr">
      {messages.rowsPerPage.defaultMessage}
      <select
        onChange={({ target }) =>
          onChange({ offset: offset, limit: parseInt(target.value, 10) })
        }
        value={limit}
        className="mr-48"
      >
        {perPageOptions.map(perPageOption => (
          <option key={perPageOption} value={perPageOption}>
            {perPageOption}
          </option>
        ))}
      </select>
      <span data-testid="page-info" className="mr-48">
        <FormattedMessage
          {...messages.paginationInfo}
          values={{
            offset: offset + 1,
            limit: offset + limit > total ? total : offset + limit,
            total: total
          }}
        />
      </span>
      <button
        data-testid="previous"
        className="no-focus"
        onClick={() =>
          onChange({
            offset: offset - limit < 0 ? 0 : offset - limit,
            limit
          })
        }
        disabled={offset === 0}
      >
        <Chevron
          title={messages.previous.defaultMessage}
          className="mr-24"
          rotateDegree={90}
          height="13px"
          width="13px"
          fill="#343434"
        />
      </button>
      <button
        data-testid="next"
        className="no-focus"
        onClick={() => onChange({ offset: offset + limit, limit })}
        disabled={offset + limit >= total}
      >
        <Chevron
          title={messages.next.defaultMessage}
          rotateDegree={270}
          height="13px"
          width="13px"
          fill="#343434"
        />
      </button>
    </div>
  );
};

export default Pagination;
